import React from "react";
import { statusChipStyle } from "./partnersMobileUtils";

// Same anatomy as Subcomponents/LeadStatusChip (6px dot + capitalised label),
// rebuilt in px so it does not shrink under App.css's mobile rem rescaling.
export default function StatusBadge({ status, disabled }) {
  const { label, color, backgroundColor } = statusChipStyle({ status, disabled });

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "2px 10px",
        borderRadius: 16,
        fontFamily: "Inter-Medium",
        fontSize: 12,
        fontWeight: 500,
        lineHeight: "18px",
        textTransform: "capitalize",
        whiteSpace: "nowrap",
        color,
        backgroundColor,
      }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          backgroundColor: "currentColor",
          flexShrink: 0,
        }}
      />
      <span>{label}</span>
    </span>
  );
}
